import { useMemo } from 'react'

import { useTrackingSources } from '@/lib/features/Assets/api'

export const useTrackingSourceOptions = () => {
  const { data: trackingSources } = useTrackingSources()

  return useMemo(() => {
    return (
      trackingSources?.map((source) => ({
        label: source.name,
        value: source.id,
      })) ?? []
    )
  }, [trackingSources])
}
